import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import session from "./session";
import dmReducer from "./dm";
import channelMessageReducer from "./channelMessage";
import searchReducer from "./search";
import channelsReducer from "./channels";
import groupReducer from "./groups";

const rootReducer = combineReducers({
  session,
  dm: dmReducer,
  channelMessages: channelMessageReducer,
  search: searchReducer,
  channels: channelsReducer,
  search: searchReducer,
  channels: channelsReducer,
  group: groupReducer,
});

let enhancer;

if (process.env.NODE_ENV === "production") {
  enhancer = applyMiddleware(thunk);
} else {
  const logger = require("redux-logger").default;
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  enhancer = composeEnhancers(applyMiddleware(thunk, logger));
}

const configureStore = (preloadedState) => {
  return createStore(rootReducer, preloadedState, enhancer);
};

export default configureStore;
